import { agent } from '../utils/agent'
const API_URL = process.env.REACT_APP_API_URL

const getCommunityPosts = async (
  postType,
  offset = 0,
  itemsPerPage = 0,
  activePage = 0,
  params = [],
) => {
  const response = await agent.get(
    `${API_URL}community-posts/listing?post_type=${postType}&offset=${offset}&limit=${itemsPerPage}&page=${activePage}&${params}`,
  )
  return response.data
}

const getStats = async (postType = null) => {
  let url = `${API_URL}community-posts/stats`

  if (postType) {
    url += `?post_type=${postType}`
  }

  const response = await agent.get(url)
  return response.data
}

const updatePostStatus = async (postId, isActive) => {
  const response = await agent.post(`${API_URL}community-posts/update-status/${postId}`, {
    is_active: isActive,
  })
  return response.data
}

const bulkUpdateStatus = async (postIds, isActive) => {
  const response = await agent.post(`${API_URL}community-posts/bulk-update-status`, {
    post_ids: postIds,
    is_active: isActive,
  })
  return response.data
}

const CommunityPostsService = {
  getCommunityPosts,
  getStats,
  updatePostStatus,
  bulkUpdateStatus,
}

export default CommunityPostsService
